













import 'material-design-icons-iconfont/dist/material-design-icons.css';
import './App.css';
import { Component } from 'vue-property-decorator';
import SnackBarComponent from '@/shared/snackbar/snackbar.component.vue';
import Vue from './vue.type';
import FooterMandala from './shared/layout/mandala-footer.component.vue';
import SideBarMandala from './shared/side-bar/mandala-side-bar.component.vue';
import MandalaHeaderComponent from './shared/layout/mandala-header.component.vue';
import AuthenticationService from './domain/security/authentication.service';
import AuthorityStore from './domain/security/authority.store';

@Component({
  components: {
    SideBarMandala,
    MandalaHeaderComponent,
    FooterMandala,
    SnackBarComponent,
  },
})

export default class App extends Vue {
  private loadingAuthorities: boolean = true;

  private authorities: any = [];

  created() {
    this.getAuthorities();
  }

  get isAuthenticated(): boolean {
    return this.$store.getters.isAuthenticated;
  }

  get isHomolog() {
    return process.env.VUE_APP_HOST_URL_BASE.includes('homolog') || process.env.VUE_APP_HOST_URL_BASE.includes('localhost');
  }

  private getAuthorities() {
    this.loadingAuthorities = true;
    return AuthorityStore.fetchedAuthority()
      .then((resp: any) => {
        this.authorities = resp.authorities;
      })
      .catch((err: any) => AuthenticationService.logout())
      .finally(() => { this.loadingAuthorities = false; });
  }
}
